"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenderLabel = exports.Gender = void 0;
var Gender;
(function (Gender) {
    Gender["FEMININE"] = "F";
    Gender["FEMININE_PLURAL"] = "FP";
    Gender["MASCULINE"] = "M";
    Gender["MASCULINE_PLURAL"] = "MP";
})(Gender || (exports.Gender = Gender = {}));
var getGenderLabel = function (gender) {
    switch (gender) {
        case Gender.FEMININE:
            return 'Féminin singulier';
        case Gender.FEMININE_PLURAL:
            return 'Féminin pluriel';
        case Gender.MASCULINE:
            return 'Masculin singulier';
        case Gender.MASCULINE_PLURAL:
            return 'Masculin pluriel';
        default:
            return 'Rien';
    }
};
exports.getGenderLabel = getGenderLabel;
//# sourceMappingURL=gender.js.map